import axios from 'axios';
import { getKeycloak } from '../keycloak';   // singleton já criado no bootstrap

// Instância base
const api = axios.create({
    baseURL: process.env.REACT_APP_IOT_HUB_BASE_URL || 'https://iot.bioailab.com.br',
    timeout: 10000,
});

// ▸ Interceptor de request: garante token válido e injeta o header
api.interceptors.request.use(
    async (config) => {
        const kc = getKeycloak();               // sempre a mesma instância
        if (!kc) return config;                 // Keycloak ainda inicializando

        try {
            // se o token expira em ≤30 s, faz refresh silencioso
            await kc.updateToken(30);
        } catch (e) {
            console.warn('Falha ao renovar token', e);
            // se falhar, segue sem atualizar; backend pode devolver 401
        }

        if (kc.token) {
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${kc.token}`,
            };
        }
        return config;
    },
    (error) => Promise.reject(error),
);

// ▸ Interceptor de response: se 401, volta para a página de login
api.interceptors.response.use(
    (resp) => resp,
    (error) => {
        if (error.response?.status === 401) {
            console.warn('Sessão expirada — redirecionando para login');
            // limpa o token local e volta para "/"
            const kc = getKeycloak();
            kc?.clearToken?.();
            window.location.replace('/');         // forçar novo login
        }
        return Promise.reject(error);
    },
);

export default api;
